module.exports = __webpack_public_path__ + "static/media/ODD.8d240ecd.mp4";